import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StatusScreenTypeEnum } from '@qvs/core';
import { statusScreenBannerUrlMap } from '~/shared/components/status-screen/statusScreenBannerUrlMap';
import { statusScreenIconUrlMap } from '~/shared/components/status-screen/statusScreenIconUrlMap';
import { isNil } from 'lodash-es';
import { TranslatePipe } from '@ngx-translate/core';
import { StatusScreenBannerComponent } from '../status-screen-banner/status-screen-banner.component';
import { ScrollDirective } from '../../directives/scroll.directive';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { PageHeaderCloseComponent } from '../page-header-close/page-header-close.component';
import { NgIf, NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'qvs-status-screen',
  templateUrl: './status-screen.component.html',
  styleUrls: ['./status-screen.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgIf,
    PageHeaderCloseComponent,
    PageHeaderComponent,
    ScrollDirective,
    StatusScreenBannerComponent,
    NgClass,
    TranslatePipe
  ]
})
export class StatusScreenComponent implements OnInit {
  @Input() title: string;
  @Input() type: StatusScreenTypeEnum;
  @Input() showCloseButton = true;
  @Input() showTitle = true;
  @Input() closeButtonText: string;
  @Input() showHeaderCloseButton: boolean;
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();
  readonly statusScreenType = StatusScreenTypeEnum;
  statusScreenBannerUrlMap: Map<StatusScreenTypeEnum, string>;
  statusScreenIconUrlMap: Map<StatusScreenTypeEnum, string>;

  constructor() {
    this.statusScreenBannerUrlMap = statusScreenBannerUrlMap;
    this.statusScreenIconUrlMap = statusScreenIconUrlMap;
  }

  ngOnInit() {
    if (isNil(this.showHeaderCloseButton)) {
      this.showHeaderCloseButton = this.showCloseButton;
    }
  }
}
